/**
 * CONNOX GMBH CONFIDENTIAL
 * ________________________
 *
 * Copyright (c) 2005 - 2018 Connox GmbH, All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the property
 * of Connox GmbH and its suppliers, if any. The intellectual and
 * technical concepts contained herein are proprietary to Connox GmbH and
 * its suppliers and may be covered by German Laws and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material is
 * strictly forbidden unless prior written permission is obtained from
 * Connox GmbH.
 */

import {BaseRequestHandler} from "../requestHandler/BaseRequestHandler";

export class RatingsFactory {
  public static async getRatings(salesChannelId: number, data: ILoadShopRatings): Promise<IShopRatingResult> {
    return await BaseRequestHandler.performRequest<IShopRatingResult>("GET", `/shop/${salesChannelId}/ratings`, {
      params: {...data, itemIds: data.itemIds.toString()},
    });
  }
}

export interface IShopRatingResult {
  summary?: IShopRatingSummary;
  summaryWithAssociatedPointTransactions?: IShopRatingSummary;
  ratings: IShopRating[];
}

export interface IShopRatingSummary {
  1: number;
  2: number;
  3: number;
  4: number;
  5: number;
}

export interface IShopRating {
  itemId: number;
  itemName: string;
  subject: string;
  positive: number;
  negative: number;
  rating: number;
  content: string;
  translated: boolean;
  created: string;
  ownerRemark: string | null;
  customerName: string;
  hasAssociatedPointTransaction: boolean;
}

export interface ILoadShopRatings {
  itemIds: number[];
  limit?: number;
  offset?: number;
  summary?: boolean;
  ratings?: boolean;
}
